import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { IGeodeticLocation } from "../dto/IGeodeticLocation";
import { IResultPayload } from "../dto/IResultPayload";
import { BaseService } from "../services/base-service";
import { IRouterRefNrId } from "../types/IRouteRefNrId";
import SinglePointDataTable from "./content/SinglePointDataTable";
import {Tabs, Tab} from "react-bootstrap";
import {useTranslation} from 'react-i18next';

const SinglePointDisplay = () => {
    
    const { refNrId } = useParams() as IRouterRefNrId;
    const [fetchResult, setFetchResult] = useState({} as IGeodeticLocation);
    const [key, setKey] = useState("info");
    const [loadingError, setLoadingError] = useState(""); 
    const iframeStyle = {
        width: '100%',
        height: '600px',
    };
    const [mapLoaded, setMapLoaded] = useState(false);
    const {t} = useTranslation();

    const loadData = async () => {
        setLoadingError("");
        let result = await BaseService.findByRefNrId<IResultPayload>("/getgeodeticpointinfo/" + refNrId);

        if (result.ok && result.data) {
            if ((Object.keys(result.data).length !== 0 && result.data?.totalElements !== 0)) {
                setFetchResult(result.data.allLocations![0]);
            } else {
                setLoadingError(t('singleNoPointError').toString());
            }
        } else if(result.ok && !result.data) {
            setLoadingError(t('singleNoPointError').toString());
        } else {
            setLoadingError(t('singleQueryError', {errorCode: result.statusCode}).toString());
        }
    }
    
    useEffect(() => {
        loadData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function setTabKey(key: string | null) {
        if (key !== null ) {
            setKey(key)
            if (key === "map" && mapLoaded === false) {
                const xgisScript = document.createElement('script');
                xgisScript.src = "https://xgis.maaamet.ee/xgis2/plugin/link/4yBJXbx3?bbox=" + Math.floor(fetchResult.y - 1000).toString() + "," + Math.floor(fetchResult.x-500).toString() + "," + Math.floor(fetchResult.y + 1000).toString() + "," + Math.floor(fetchResult.x + 500).toString() + "&mapdiv=mapFrame";
                xgisScript.async = true;
                setTimeout(function() {
                    document.body.appendChild(xgisScript);
                }, 100);
                xgisScript.remove();
                setMapLoaded(true);
            }
        }
    }
 
    return (
        <>
            {loadingError !== "" &&
                loadingError
            }


            {Object.keys(fetchResult).length > 0 &&
                <Tabs activeKey={key} onSelect={(k) => setTabKey(k)} id="uncontrolled" className="mb-3">
                    <Tab eventKey="info" title={t('singleTabInfoTitle')}>
                        <SinglePointDataTable geodeticLocationData = {fetchResult} />
                    </Tab>
                    <Tab eventKey="map" title={t('singleTabMapTitle')}>
                        <span style={{color: 'red'}}>{t('chromiumWarning')}</span>
                        <div style={{backgroundAttachment: "scroll", boxSizing: "border-box", backfaceVisibility: "hidden", display: "block"}}>
                            <div id="mapFrame" style={{height: "650px", width: "100%", position: "relative", display: "inline-block"}}>
                            </div>
                        </div>
                    </Tab>
                    <Tab eventKey="kaldKaamera" title={t('singleTabCameraTitle')}>
                        <iframe 
                        title="Kaldkaamera pildid" 
                        sandbox="allow-same-origin allow-scripts" 
                        style={iframeStyle} src={"https://www.maaamet.ee/fotoladu/etak.php?x=" + fetchResult.x + "&y=" + fetchResult.y } />
                    </Tab>
                </Tabs>
            }
        </>
    );
}

export default SinglePointDisplay;

 